import { z } from 'zod';

import { ScriptKey, ScriptPhase, StepType, TaskType } from './asset.enums.ts';

export enum SpeakableScriptPartType {
  Text = 'TEXT',
  Letter = 'LETTER',
}

export type SpeakableScriptPart =
  | {
      text: string;
      type: SpeakableScriptPartType.Text;
    }
  | {
      letter: string;
      type: SpeakableScriptPartType.Letter;
    };

export interface ScriptProcessingResult {
  parts: SpeakableScriptPart[];
  processed: boolean;
}

export const ScriptsSchema = z.record(
  z.nativeEnum(TaskType),
  z.record(z.nativeEnum(StepType), z.record(z.nativeEnum(ScriptPhase), z.record(z.nativeEnum(ScriptKey), z.string())))
);

export type Scripts = z.infer<typeof ScriptsSchema>;
